import { Divider } from 'antd';
import styled from 'styled-components';

export const InquiryItemDivider = styled(Divider)`
  margin-top: 12px;
  margin-bottom: 12px;
`;
